import { render, staticRenderFns } from "./News.vue?vue&type=template&id=5ce8c766&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&id=5ce8c766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce8c766",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce8c766')) {
      api.createRecord('5ce8c766', component.options)
    } else {
      api.reload('5ce8c766', component.options)
    }
    module.hot.accept("./News.vue?vue&type=template&id=5ce8c766&scoped=true&", function () {
      api.rerender('5ce8c766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Home/News.vue"
export default component.exports